import React, { createContext, useContext, useState, useEffect } from 'react';
import i18n from '../i18n/i18n';

const I18nContext = createContext();

export const useI18n = () => {
  const context = useContext(I18nContext);
  if (!context) {
    throw new Error('useI18n must be used within an I18nProvider');
  }
  return context;
};

export const I18nProvider = ({ children }) => {
  const [language, setLanguageState] = useState(i18n.getLanguage());

  useEffect(() => {
    const handleLanguageChange = (event) => {
      setLanguageState(event.detail.language);
    };

    window.addEventListener('languageChanged', handleLanguageChange);
    return () => {
      window.removeEventListener('languageChanged', handleLanguageChange);
    };
  }, []);

  const setLanguage = (lang) => {
    i18n.setLanguage(lang);
    setLanguageState(lang);
  };

  const t = (key, params) => {
    return i18n.t(key, params);
  };

  const value = {
    language,
    setLanguage,
    t,
    supportedLanguages: i18n.getSupportedLanguages(),
    getLanguageName: i18n.getLanguageName.bind(i18n)
  };

  return (
    <I18nContext.Provider value={value}>
      {children}
    </I18nContext.Provider>
  );
};

